import { FC, ElementType } from 'react';
import { Box, SxProps } from '@mui/material';
import useHighlightedText from '#/hooks/useHighlightedText';

type ClickHandlers = {
  [key: string]: () => void;
};

const HighlightedTextFormat: FC<{
  context: string;
  targets: string[];
  onClickHandlers: ClickHandlers;
  component?: ElementType;
  sx?: SxProps;
}> = ({
  context,
  targets,
  onClickHandlers,
  component = 'span',
  sx,
  ...props
}) => {
  const normalizedHandlers = Object.entries(onClickHandlers).reduce(
    (acc, [key, handler]) => ({
      ...acc,
      [key.toLowerCase()]: handler,
    }),
    {} as ClickHandlers
  );

  const highlightFormat = (word: string, key: number) => (
    <Box
      component={component}
      key={key}
      sx={{ color: 'primary.main', cursor: 'pointer', ...sx }}
      onClick={() => {
        const handler = normalizedHandlers[word.toLowerCase()];
        if (handler) {
          handler();
        }
      }}
      {...props}
    >
      {word}
    </Box>
  );

  const highlightedText = useHighlightedText({
    targets,
    highlightFormat,
  });

  return <>{highlightedText(context)}</>;
};

export default HighlightedTextFormat;
